/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_1_Item_1_DetailInputs */

const en_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inducted 2022 · Golf Professional / Teacher`)
};

const es_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporado en 2022 · Profesional de golf / profesor`)
};

const de_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgenommen 2022 · Golfprofessional / Golflehrer`)
};

const zh_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022 年入选 · 高尔夫职业人士 / 教师`)
};

const ar_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أُدخل عام 2022 · محترف غولف / معلّم`)
};

const fr_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intronisé en 2022 · Professionnel de golf / enseignant`)
};

const vi_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Được vinh danh năm 2022 · Chuyên gia golf / giáo viên`)
};

const sw_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aliingizwa 2022 · Mtaalamu wa Gofu / Mwalimu`)
};

const th_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ได้รับเลือกเข้าหอเกียรติยศปี 2022 · นักกอล์ฟมืออาชีพ / ครูสอนกอล์ฟ`)
};

const bs_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uveden 2022. · Golf profesionalac / učitelj`)
};

const ja_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022年殿堂入り · ゴルフプロ / 教師`)
};

const ko_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022년 헌액 · 골프 프로 / 교사`)
};

const pt_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluído em 2022 · Profissional de golfe / professor`)
};

const it_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserito nel 2022 · Professionista di golf / insegnante`)
};

const sv_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invald 2022 · Golfprofessional / lärare`)
};

const nl_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgenomen 2022 · Golfprofessional / Leraar`)
};

const da_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optaget 2022 · Golfprofessionel / træner`)
};

const nb_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innlemmet 2022 · Golfprofesjonell / lærer`)
};

const fi_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valittu 2022 · Golfammattilainen / opettaja`)
};

const pl_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wprowadzony w 2022 · zawodowy golfista / nauczyciel`)
};

const ru_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введён в 2022 г. · Профессионал гольфа / преподаватель`)
};

const tr_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022'de seçildi · Golf profesyoneli / öğretmen`)
};

const hi_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2022 में शामिल · गोल्फ प्रोफ़ेशनल / शिक्षक`)
};

const id_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dilantik 2022 · Profesional golf / guru`)
};

const ms_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diabadikan pada 2022 · Profesional golf / guru`)
};

const cs_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uveden 2022 · golfový profesionál / učitel`)
};

const el_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εισήχθη το 2022 · Επαγγελματίας γκολφ / δάσκαλος`)
};

const he_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נכנס להיכל התהילה ב-2022 · מקצוען גולף / מורה`)
};

const af_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgeneem in 2022 · Gholfprofessional / onderwyser`)
};

const hu_about_content_honor_1_item_1_detail = /** @type {(inputs: About_Content_Honor_1_Item_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beválasztva 2022 · golfprofi / tanár`)
};

/**
* | output |
* | --- |
* | "Inducted 2022 · Golf Professional / Teacher" |
*
* @param {About_Content_Honor_1_Item_1_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_1_item_1_detail = /** @type {((inputs?: About_Content_Honor_1_Item_1_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_1_Item_1_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_1_item_1_detail(inputs)
	if (locale === "de") return de_about_content_honor_1_item_1_detail(inputs)
	if (locale === "zh") return zh_about_content_honor_1_item_1_detail(inputs)
	if (locale === "ar") return ar_about_content_honor_1_item_1_detail(inputs)
	if (locale === "fr") return fr_about_content_honor_1_item_1_detail(inputs)
	if (locale === "vi") return vi_about_content_honor_1_item_1_detail(inputs)
	if (locale === "sw") return sw_about_content_honor_1_item_1_detail(inputs)
	if (locale === "th") return th_about_content_honor_1_item_1_detail(inputs)
	if (locale === "bs") return bs_about_content_honor_1_item_1_detail(inputs)
	if (locale === "ja") return ja_about_content_honor_1_item_1_detail(inputs)
	if (locale === "ko") return ko_about_content_honor_1_item_1_detail(inputs)
	if (locale === "pt") return pt_about_content_honor_1_item_1_detail(inputs)
	if (locale === "it") return it_about_content_honor_1_item_1_detail(inputs)
	if (locale === "sv") return sv_about_content_honor_1_item_1_detail(inputs)
	if (locale === "nl") return nl_about_content_honor_1_item_1_detail(inputs)
	if (locale === "da") return da_about_content_honor_1_item_1_detail(inputs)
	if (locale === "nb") return nb_about_content_honor_1_item_1_detail(inputs)
	if (locale === "fi") return fi_about_content_honor_1_item_1_detail(inputs)
	if (locale === "pl") return pl_about_content_honor_1_item_1_detail(inputs)
	if (locale === "ru") return ru_about_content_honor_1_item_1_detail(inputs)
	if (locale === "tr") return tr_about_content_honor_1_item_1_detail(inputs)
	if (locale === "hi") return hi_about_content_honor_1_item_1_detail(inputs)
	if (locale === "id") return id_about_content_honor_1_item_1_detail(inputs)
	if (locale === "ms") return ms_about_content_honor_1_item_1_detail(inputs)
	if (locale === "cs") return cs_about_content_honor_1_item_1_detail(inputs)
	if (locale === "el") return el_about_content_honor_1_item_1_detail(inputs)
	if (locale === "he") return he_about_content_honor_1_item_1_detail(inputs)
	if (locale === "af") return af_about_content_honor_1_item_1_detail(inputs)
	if (locale === "hu") return hu_about_content_honor_1_item_1_detail(inputs)
	return en_about_content_honor_1_item_1_detail(inputs)
});